<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card>
      <v-card-title v-if="title" class="headline justify-center">{{ title }}</v-card-title>
      <v-card-text v-if="text">{{ text }}</v-card-text>
      <v-card-actions class="justify-center">
        <v-btn @click="$emit('confirm', false)" outlined color="blue-grey lighten-3">取消</v-btn>
        <v-btn @click="$emit('confirm', true)" color="teal" class="ml-3">確認</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>



<script>
export default {
  components: {},

  mixins: [],

  props: ["dialog", "title", "text"],
  data() {
    return {};
  },

  computed: {},
  watch: {},
  methods: {},

  mounted() {}
};
</script>

<style lang="scss" scoped>
</style>
